import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { injectIntl, defineMessages } from 'react-intl';

import { validImage } from '../../../_helpers/validation';

import StatusMessage from './StatusMessage';
import ViewImage from './ViewImage';
import EditImage from './EditImage';

const Wrapper = styled.div`
  width: 100%;
`;

class Main extends React.Component {
  wrapperRef = React.createRef();

  state = {
    imgFile: null,
    invalidImgError: false,
  };

  messages = defineMessages({
    error1: {
      id: 'ProfileImageEditor.error1',
      defaultMessage: 'An error occured. Please try again later',
    },
    error2: {
      id: 'ProfileImageEditor.error2',
      defaultMessage: 'Please upload a valid image file under 5 mb.',
    },
  });

  componentDidUpdate(prevProps) {
    const { imgSrc: prevImgSrc } = prevProps;
    const { imgSrc } = this.props;

    if (imgSrc !== prevImgSrc) {
      // Update success
      // Show viewer
      this._updateImgFile(null);
    }
  }

  _updateImgFile = (imgFile) => {
    this.setState({
      imgFile,
    });
  };

  _photoChangeHandler = (e) => {
    const imgFile = e.target.files[0];

    if (validImage(imgFile)) {
      this._updateImgFile(imgFile);
    } else {
      this.setState({
        invalidImgError: true,
      });
    }
  };

  _handleImgSubmit = (imgData) => {
    const { _submitImgHandler } = this.props;

    this.setState({
      invalidImgError: false,
    });
    _submitImgHandler(imgData);
  };

  _renderEditor = () => {
    const { imgSrc } = this.props;
    const { imgFile } = this.state;

    if (imgFile) {
      return (
        <EditImage
          _cancelHandler={this._updateImgFile}
          _submitHandler={this._handleImgSubmit}
          imgFile={imgFile}
          size={this.wrapperRef.current.offsetWidth}
        />
      );
    }

    return (
      <ViewImage
        _handlePhotoChange={this._photoChangeHandler}
        imgSrc={imgSrc}
      />
    );
  };

  _renderError = () => {
    const {
      intl: { formatMessage },
      error,
    } = this.props;
    const { invalidImgError } = this.state;

    if (error) {
      const status = {
        message: formatMessage(this.messages.error1),
        type: 'error',
      };

      return <StatusMessage status={status} />;
    }

    if (invalidImgError) {
      const status = {
        message: formatMessage(this.messages.error2),
        type: 'error',
      };

      return <StatusMessage status={status} />;
    }

    return null;
  };

  render() {
    return (
      <Wrapper ref={this.wrapperRef}>
        {this._renderEditor()}
        {this._renderError()}
      </Wrapper>
    );
  }
}

Main.propTypes = {
  /** Accepts argument of Base 64 encoded image data */
  _submitImgHandler: PropTypes.func.isRequired,
  error: PropTypes.bool,
  imgSrc: PropTypes.string.isRequired,
  intl: PropTypes.shape({ formatMessage: PropTypes.func.isRequired }).isRequired,
};

Main.defaultProps = {
  error: false,
};

export default injectIntl(Main);
